/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { isStringNotEmpty } from "utils/empty-exists";
import { InvalidModel } from "data/dto/model/invalid-model.error";
import Config from "data/config";
import { Logger } from "cms/utils/log/logger";

/**
 * Vaildate the model payload
 * @param {object} model
 * @throws {InvalidModel}
 */
export function ModelValidator (model) {
    
    // Validate Common Fields
    const title = model?.title;
    const description = model?.description;
    if (!isStringNotEmpty(title)) {
        throw new InvalidModel("You must supply a title", 2001);
    }
    if (!isStringNotEmpty(description)) {
        throw new InvalidModel("You must supply a description", 2002);
    }
    
    // Validate Model by Schema
    const fields = model?.fields;
    for (const field of fields) {
        const name = field?.name;
        if (Config.Logging.enableSavePipelineLog) {
            Logger.info(`[ModelValidator] field name:${name}`);
        }
    }
    
}
